import { MessageSquare } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { SocialDMsView } from "./SocialDMsView";

export function SocialDMsPage() {
  return (
    <div>
      <PageHeader
        icon={MessageSquare}
        title="Messages"
        description="Manage direct messages and comments across all your connected social accounts in a unified inbox. Reply to audiences, assign conversations to team members, and track response times."
      />
      <SocialDMsView />
    </div>
  );
}
